// extracted by mini-css-extract-plugin
export default {"section":"AreasServed_section__4jIpq","boxed":"AreasServed_boxed__xRpVX","cta":"AreasServed_cta__yK+Af","note":"AreasServed_note__lAp8m"};